import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-app-copyright',
  templateUrl: './app-copyright.component.html',
  styleUrls: ['./app-copyright.component.scss']
})
export class AppCopyrightComponent implements OnInit {

  constructor(public router: Router) {}

  ngOnInit(): void {
  }

}
